import { PageHero, SectionHead, Reveal, Card, usePageMeta } from "@/components/primitives";
import { ArchSection, SecurityPillars, FinalCTA } from "@/components/blocks2";
import { IntelligenceCards, TechLine } from "@/components/blocks1";

const PRINCIPLES = [
  { title: "Intelligence-First", body: "Every architectural decision starts from the intelligence layer: what signals exist, how risk is scored, how trust is enforced." },
  { title: "API-Led", body: "Banks, NBFCs, insurers and FinTechs integrate through secure, well-governed APIs — not bespoke plumbing." },
  { title: "Privacy by Design", body: "Data minimisation, consent-first flows and purpose limitation are defaults, not options." },
  { title: "Real-Time Decisioning", body: "Risk, fraud and compliance signals are evaluated in the flow of the transaction, not after it." },
];

export default function Technology() {
  usePageMeta(
    "TimePe Technology | AI, Fraud Intelligence & RegTech Solutions",
    "TimePe's intelligence-first financial infrastructure: AI fraud intelligence, real-time risk intelligence, RegTech, privacy by design and secure API architecture."
  );
  return (
    <>
      <PageHero
        eyebrow="Technology"
        lines={["Intelligence-First", "Financial Infrastructure."]}
        lead="TimePe is engineered as a layered, API-led platform where fraud intelligence, risk intelligence, compliance and privacy sit beneath every journey."
      >
        <TechLine />
      </PageHero>

      <ArchSection />

      <IntelligenceCards showCta={false} />

      <section className="border-b border-line py-24 sm:py-32" data-testid="tech-principles">
        <div className="mx-auto max-w-[1440px] px-6 lg:px-8">
          <SectionHead eyebrow="Design Principles" title="How We Engineer Trust" />
          <div className="mt-14 grid gap-5 sm:grid-cols-2 lg:grid-cols-4">
            {PRINCIPLES.map((p, i) => (
              <Reveal key={p.title} delay={i * 0.07}>
                <Card testid={`principle-card-${i}`} className="h-full p-7">
                  <p className="font-mono text-xs text-electric">{String(i + 1).padStart(2, "0")}</p>
                  <h3 className="mt-4 font-display text-lg font-semibold text-mist">{p.title}</h3>
                  <p className="mt-3 text-sm leading-relaxed text-mute">{p.body}</p>
                </Card>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      <SecurityPillars />
      <FinalCTA />
    </>
  );
}
